<div class="main-content">
  <app-loader></app-loader>
  <router-outlet />
</div>
